const textGrey = "#333333";
const primaryDark = "#004A3C";

const createTypography = (theme) => ({
  // Revert primary font back to Open Sans (user preference), keep Poppins as fallback
  fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),

  // ============================================
  // H1 Variants - Large headers
  // ============================================
  h1: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "14px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },
  h1NoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    /* headers should always have margin — make NoMargin match the regular h1 */
    marginBottom: "14px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },
  h1White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "14px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },
  h1WhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "14px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },
  h1Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "14px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },
  h1DarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "14px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "18px",
    },
  },

  // ============================================
  // H2 Variants - Section headers
  // ============================================
  h2: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },
  h2NoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },
  h2White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },
  h2WhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },
  h2Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },
  h2DarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "12px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "22px",
      marginBottom: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "24px",
      marginBottom: "18px",
    },
  },

  // ============================================
  // H3 Variants - Sub-section headers
  // ============================================
  h3: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },
  h3NoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },
  h3White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },
  h3WhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },
  h3Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },
  h3DarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "10px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
      marginBottom: "14px",
    },
  },

  // ============================================
  // H4 Variants - Small headers
  // ============================================
  h4: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },
  h4NoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },
  h4White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },
  h4WhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },
  h4Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },
  h4DarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "12px",
    },
  },

  // ============================================
  // Body1 Variants - Standard body text (larger)
  // NOTE: `p1` is the paragraph variant (with margin)
  // and `body1` is the no-margin body text (previously body1NoMargin).
  // ============================================
  p1: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    // bumped up for readability
    fontSize: "14px",
    marginBottom: "8px",
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
      marginBottom: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
  },
  // body1 now represents the no-margin body text
  body1: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    // same readable sizes as p1 but no margin
    fontSize: "14px",
    marginBottom: 0,
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
    },
  },
  // Keep body1NoMargin as an alias to body1 for backward compatibility
  body1NoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: 0,
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
    },
  },

  // ============================================
  // Button variant - used by MUI Button by default
  // ============================================
  button: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    lineHeight: 1.2,
    fontWeight: 600,
    textTransform: "none",
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },

  // Provide paragraph variants for colored body styles
  p1White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "8px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
  },
  p1Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "8px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
  },

  // Inline link variant to use inside paragraphs (matches link styling but inline)
  p1Link: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    // use smaller rem size on mobile to match 14px p1 text better
    fontSize: "0.9rem", // ~14.4px, closer to 14px p1 text
    marginBottom: 0,
    color: theme.palette.link ? theme.palette.link.main : "#0099cc",
    lineHeight: 1.4,
    fontWeight: 600,
    marginTop: 0,
    textDecoration: "underline",

    [theme.breakpoints.up("md")]: {
      fontSize: "1.0rem", // 16px to match 16px p1 text on md+
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.125rem", // 18px to match 18px p1 text on lg+
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "1.25rem", // 20px to match 20px p1 text on xl+
    },
  },

  // Keep existing colored body variants (no-margin) for backward compat
  body1White: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "8px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
      marginBottom: "10px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
      marginBottom: "14px",
    },
  },
  body1WhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: 0,
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
    },
  },
  body1Dark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "4px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
      marginBottom: "8px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
      marginBottom: "10px",
    },
  },
  body1DarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: 0,
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },

  // ============================================
  // Special Page Title Variants (larger sizes for page headers)
  // ============================================
  pageTitle: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },
  pageTitleNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },
  pageTitleWhite: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },
  pageTitleWhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },
  pageTitleDark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },
  pageTitleDarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "24px",
    marginBottom: "16px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "32px",
      marginBottom: "24px",
    },
  },

  // ============================================
  // Splash/Hero Variants (extra large text for landing page)
  // ============================================
  splashTitle: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "36px",
    marginBottom: "8px",
    color: "white",
    lineHeight: 1.2,
    fontWeight: 700,
    marginTop: 0,
    textShadow: "2px 2px rgba(0, 22, 15, 1)",

    [theme.breakpoints.up("md")]: {
      fontSize: "48px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "64px",
    },
  },
  splashSubtitle: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "24px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 400,
    marginTop: 0,
    textShadow: "1px 1px rgba(0, 22, 15, 1)",

    [theme.breakpoints.up("md")]: {
      fontSize: "22px",
    },
  },
  splashDescription: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "14px",
    marginBottom: "24px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,
    textShadow: "1px 1px rgba(0, 22, 15, 1)",

    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
  },

  // ============================================
  // Header Title Variant (for app header)
  // ============================================
  headerTitle: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    lineHeight: "18px",
    marginBottom: 0,
    color: "white",
    display: "inline-block",
    marginTop: 0,
    fontWeight: 700,

    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      lineHeight: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
      lineHeight: "20px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      lineHeight: "22px",
    },
  },

  // ============================================
  // Menu Item Variants
  // ============================================
  menuItem: {
    // increase menu item size and spacing for readability
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: "16px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 400,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
      marginBottom: "18px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
      marginBottom: "20px",
    },
  },
  menuItemNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "18px",
    marginBottom: 0,
    color: "white",
    lineHeight: 1.4,
    fontWeight: 400,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
    },
  },
  menuSectionTitle: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "8px",
    color: "rgba(255, 255, 255, 0.6)",
    lineHeight: 1.4,
    fontWeight: 600,
    marginTop: 0,
    textTransform: "uppercase",
    letterSpacing: "0.5px",

    [theme.breakpoints.up("md")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
  },

  // ============================================
  // Label/Caption Variants (small text)
  // ============================================
  label: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "4px",
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  labelNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: 0,
    color: textGrey,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  labelWhite: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "4px",
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  labelWhiteNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: 0,
    color: "white",
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  labelDark: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: "4px",
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  labelDarkNoMargin: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "12px",
    marginBottom: 0,
    color: primaryDark,
    lineHeight: 1.4,
    fontWeight: 500,
    marginTop: 0,

    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },

  // ============================================
  // Form Label Variants (used in form inputs)
  // ============================================
  formLabel: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "20px",
    marginBottom: 0,
    backgroundColor: primaryDark,
    color: "white",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    padding: "8px 16px",
    width: "100%",
    boxSizing: "border-box",
    lineHeight: 1.4,
  },

  // ============================================
  // Popover Menu Item (legacy - kept for compatibility)
  // ============================================
  popoverMenuItem: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    color: "white",
    fontSize: "1rem",
    marginBottom: "0.8rem",
    fontWeight: "bold",
    lineHeight: 1.4,

    [theme.breakpoints.up("md")]: {
      fontSize: "1.2rem",
      marginBottom: "0.8rem",
    },
  },

  // Keep body2w for backward compatibility
  body2w: {
    fontFamily: ["Open Sans", "poppins", "sans-serif"].join(","),
    fontSize: "0.9rem",
    marginBottom: "0.6rem",
    color: "white",
    lineHeight: 1.4,

    [theme.breakpoints.up("md")]: {
      fontSize: "0.9rem",
      marginBottom: "0.8rem",
    },
  },
});

export default createTypography;
